export const CLEAR_CREDITS = "clearCredits";
export const SET_ERROR = "setError";
export const SET_EXTRA_CREDITS = "setExtraCredits";
export const SET_INITIAL_CREDIT = "setInitialCredit";
export const SET_STANDARD_CREDIT = "setStandardCredit";
export const SET_LAST_TRANSACTIONS = "setLastTransactions";
export const SET_PLAN = "setPlan";
export const CLEAR_PLAN = "clearPlan";
